import { useMemo } from "react";

import LineKeyType from "@/utils/enums/LineKeyType";
import Valkyrie, {
  viBlf,
  viCircleDashed,
  viDoor,
  viEarth,
  viGauge,
  viListOrdered,
  viNumpad,
  viPerson,
  viPersonPlus,
  viRectangleP,
  viShare,
  viVideo,
} from "@sippy-platform/valkyrie";

import PropTypes from "prop-types";

export default function LineKeyIcon({ lineKeyId }) {
  const icon = useMemo(() => {
    switch (lineKeyId) {
      case LineKeyType.FORWARD:
        return viShare;
      case LineKeyType.CALL_PARK:
        return viRectangleP;
      case LineKeyType.SPEED_DIAL:
        return viGauge;
      case LineKeyType.LINE:
        return viPerson;
      case LineKeyType.BLF:
        return viBlf;
      case LineKeyType.URL:
        return viEarth;
      case LineKeyType.DTMF:
        return viNumpad;
      case LineKeyType.OPEN_DOOR:
        return viDoor;
      case LineKeyType.VIDEO_MONITORING:
        return viVideo;
      case LineKeyType.PAGINATION:
        return viListOrdered;
      case LineKeyType.FLEX_DESK:
        return viPersonPlus;
      default:
        return viCircleDashed;
    }
  }, [lineKeyId]);

  return <Valkyrie icon={icon} />;
}

LineKeyIcon.propTypes = {
  lineKeyId: PropTypes.number,
};
